import React, { lazy, Suspense } from 'react'
import { createRoot } from 'react-dom/client'

import loadDependencies from './services/dependencies'
import registerSw from './registerServiceWorker'
import './styles/typography.css'
import './services/polyfills'

import ErrorBoundary from './components/ErrorBoundary'
import Preloader from './components/Preloader'

const App = lazy(() => import('./App' /* webpackChunkName: "App" */))

const searchParams = new URLSearchParams(window.location.search)
const searchHasAuthParams = searchParams.has('code') || searchParams.has('access_token')

async function startDevHarness() {
    // Dev-only. The `NODE_ENV==='development'` guard makes webpack's parser drop this
    // branch (and the dynamic imports) from every production build.
    if (process.env.NODE_ENV !== 'development') return
    const params = new URLSearchParams(window.location.search)
    if (params.get('dry') === '1') {
        const { startDryBoot } = await import('./devtools/dry/boot')
        await startDryBoot()
        return
    }
    if (params.get('mock') !== '1') return
    const { worker } = await import('./devtools/msw/browser')
    await worker.start({
        onUnhandledRequest: 'warn',
        serviceWorker: { url: '/mockServiceWorker.js' },
    })
}

startDevHarness().finally(() => {
    createRoot(document.getElementById('app')).render(
        <ErrorBoundary>
            <Suspense
                fallback={searchHasAuthParams
                    ? <></>
                    : <Preloader renderLogoOnly />}
            >
                <App />
            </Suspense>
        </ErrorBoundary>
    )
})

// Browser identification
try {
    /* eslint-disable */
    navigator.who = (function () {
        try {
            const N = navigator.appName
            const ua = navigator.userAgent
            let tem
            let M = ua.match(/(opera|chrome|safari|firefox|msie)\/?\s*(\.?\d+(\.\d+)*)/i)
            if (M && (tem = ua.match(/version\/([\.\d]+)/i)) != null) M[2] = tem[1]
            M = M ? [M[1], M[2]] : [N, navigator.appVersion, '-?']
            return M.join(' ')
        } catch (e) {
            return null
        }
    })()
    /* eslint-enable */
} catch (e) { /** pass */ }

// Service Worker registration
if (window.top === window.self) { // Check if it's not embedded
    if (navigator && navigator.who) {
        // Ticket #4162 (SG-3337): SW is preventing fetch requests on Firefox
        if (navigator.who.indexOf('Firefox') < 0) registerSw()
    } else {
        registerSw()
    }
} else {
    // Disable PWA installation prompt
    window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault()
    })
}

loadDependencies()
